import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UnAuthorized from "../pages/UnAuthorized/index";
import { getroledata } from 'service/myapi';

const Authmiddleware = ({ children }) => {
  const location = useLocation();
  const { pathname } = location;
  const pathWithoutSlash = pathname.substring(1);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const myrole = getCookie('userType');
  const [allpermission, setpermission] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (myrole === 'admin') {
      setIsAdmin(true);
      setLoading(false);
    } else {
      getallroles();
    }
  }, []);

  const getallroles = async () => {
    try {
      const response = await getroledata(myrole);
      const permissions = response.data.role.permissions;
      const truePaths = permissions
        .filter(permission => permission.value)
        .map(permission => permission.path.replace(/^\//, ''));
      setpermission(truePaths);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching roles:', error);
      setLoading(false);
    }
  };

  if (!localStorage.getItem("token")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: location } }} />
      //<Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  if (loading) {
    return null;
  }

  if (isAdmin) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  const hasPermission = allpermission.some(permission =>
    pathWithoutSlash.startsWith(permission)
  );

  // const hasPermission = myrole === 'admin' || allpermission.some(permission =>
  //   pathWithoutSlash.startsWith(permission)
  // );

  return (
    <React.Fragment>
      {hasPermission ? children : <UnAuthorized />}
    </React.Fragment>
  );
};

export default Authmiddleware;
